import {useNavigate} from "react-router-dom";
import eventEmitter from "../../shared/eventEmitter";
import {getBusinessOrCustomerName} from "../../shared/sharedFunctions";

interface CustomerCardProps {
    customer: any,
}
const CustomerSearchCard: React.FC<CustomerCardProps> = ({customer}) => {
    const navigate = useNavigate();

    const goToDetails = () => {
        eventEmitter.emit('isSidebarOpen', (wasOpen: boolean) => {
            sessionStorage.setItem('sidebarWasOpen', JSON.stringify(wasOpen));
            navigate('/admin/customer-details', {
                state: {
                    customerId: customer.customerId,
                    customerName: customer.customerName,
                    propertyAddress: customer.propertyAddress,
                }
            });
        });
    };

    const goToJob = () => {
        eventEmitter.emit('isSidebarOpen', (wasOpen: boolean) => {
            sessionStorage.setItem('sidebarWasOpen', JSON.stringify(wasOpen));
            navigate(`/admin/job-details`, {
                state: {
                    jobId: customer.jobs[0].jobId,
                    customerId: customer.customerId,
                    customerName: customer.customerName,
                    propertyAddress: customer.propertyAddress
                }
            });
        });
    };

    function getAmountToShow(job) {
        if(job.jobStatus === 'GOEST')
            return ''
        if(job.jobStatus === 'DRIVEBY')
            return job.estimateAmount
        return job.amountCharged
    }

    
    return (
        <div className="resultCard">
            <div className="mainInfo" onClick={goToDetails} style={{cursor: "pointer",}}>
                <div className="customerName">
                    <a className="">
                        {/*J <span className="searchHighlight">Morrison</span>*/}
                        {customer.customerName}
                    </a>
                </div>
                <span className="propertyAddress">
                                            {customer.propertyAddress}
                                </span>
            </div>
            {customer.jobs.map(job => {
                return (
                    <>
                        <div style={{cursor: 'pointer'}} className="jobInfo" onClick={goToJob}>
                            <div className="row">
                                <div className="col-md-3 mb-3 mb-lg-0">
                                    <div className="infoBlock">
                                                    <span className="infoLabel">
                                                        Job Date
                                                    </span>
                                        <span className="infoData">
                                                            {job.dateDone}
                                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-3 mb-3 mb-lg-0">
                                    <div className="infoBlock">
                                                    <span className="infoLabel">
                                                        Amount
                                                    </span>
                                        <span className="infoData">
                                                        {getAmountToShow(job)}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-3 mb-3 mb-lg-0">
                                    <div className="infoBlock">
                                                    <span className="infoLabel">
                                                        Status
                                                    </span>
                                        <span className="infoData">
                                            {customer?.customerStatusId !== 1 ? customer.customerStatus : job.jobStatus}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            })}
        </div>
    );
}

export default CustomerSearchCard;